import { render, staticRenderFns } from "./OrderCourse.vue?vue&type=template&id=10c24d06&scoped=true&"
import script from "./OrderCourse.vue?vue&type=script&lang=js&"
export * from "./OrderCourse.vue?vue&type=script&lang=js&"
import style0 from "./OrderCourse.vue?vue&type=style&index=0&id=10c24d06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c24d06",
  null
  
)

export default component.exports